import { ArrowRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Divider,
  Flex,
  FormLabel,
  Input,
  Select,
  Tag,
  Text,
  Textarea,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import { useContext, useEffect, useState } from "react";
import { appRequest } from "routes";
import { SELLER_CLIENT_URL } from "utils/env";

interface Props {
  selectedIds: {
    issueId: string;
    transactionId: string;
  };
  currentStatus?: string;
  setCallapi?: any;
  callApi?: boolean;
  data: any;
  callIssueApi?: boolean;
  setCallIssueApi?: any;
}

export default function RespondToIssue({
  selectedIds,
  currentStatus,
  setCallapi,
  callApi,
  data,
  callIssueApi,
  setCallIssueApi,
}: Props): JSX.Element {
  const [issueStatus, setIssueStatus] = useState<string | undefined>(
    currentStatus
  );
  const [shortdescription, setShortDescription] = useState<string>("");
  const [step, setStep] = useState<number>(1); // To toggle between steps
  const { toastNotify } = useContext(AppContext);
  const [raiseToSeller, setRaiseToSeller] = useState<any>("");
  const toast = useToast();

  // Validation function
  const validateFields = (): boolean => {
    if (!issueStatus) {
      toastNotify({
        title: "Validation Error",
        message: "Status is required.",
        type: "error",
      });
      return false;
    }
    if (!shortdescription.trim()) {
      toastNotify({
        title: "Validation Error",
        message: "Short description is required.",
        type: "error",
      });
      return false;
    }

    return true; // All validations passed
  };

  const UpdateStatus = async () => {
    if (!validateFields()) return;
    try {
      let id = data?._id;
      let status = issueStatus;
      let description = shortdescription;
      const request = {
        id,
        status,
        description,
      };
      console.log("my request", request);
      const response: any = await appRequest(
        "issues",
        "updateIssueStatus",
        request
      );
      if (response.status === "success") {
        toastNotify({
          title: "Success",
          message: "Status Updated",
          type: "success",
        });
        setCallapi(!callApi);

        setIssueStatus(undefined);
        setShortDescription("");
      }
    } catch (error: any) {
      toastNotify({
        title: "Failed",
        message: "Something went wrong",
        type: "error",
      });
    }
  };

  const sendToSeller = async () => {
    let loadingToast: any;
    try {
      loadingToast = toast({
        title: "Processing",
        description: "Raising Issue with seller, please wait...",
        status: "loading",
        duration: null,
        isClosable: true,
        position: "top",
      });
      let issueId = data?._id;

      const response: any = await appRequest("issues", "raiseIssueToSeller", {
        issueId,
      });
      toast.close(loadingToast);
      if (response.status === "success") {
        toastNotify({
          title: "Success",
          message: "Issue send to Seller",
          type: "success",
        });
        setCallIssueApi(!callIssueApi);
      }
    } catch (error: any) {
      toast.close(loadingToast);
      toastNotify({
        title: "Failed",
        message: "Something went wrong",
        type: "error",
      });
      console.log("error raising issue with seller", error);
    }
  };

  return (
    <Box
      p={4}
      border="2px solid"
      borderColor="gray.200"
      w={"100%"}
      rounded={"lg"}
    >
      <VStack spacing={4}>
        {/* {step === 1 && (
          <> */}
        <Box w="100%">
          <Select
            value={issueStatus}
            onChange={(e) => setIssueStatus(e.target.value)}
            bg="white"
            placeholder="Update status"
          >
            <option value="OPEN">Open</option>
            {/* <option value="CLOSED">Closed</option> */}
            <option value="RESOLVED">Resolved</option>
            <option value="PROCESSING">Processing</option>
            <option value="ESCALATED">Escalate</option>
          </Select>
        </Box>

        <Divider />

        <Box w="100%">
          <Flex justify={"space-between"} mb={1}>
            <Text fontSize="sm" fontWeight="semibold" color="gray.600" mb={1}>
              Short Description
            </Text>
            {issueStatus && (
              <Tag
                colorScheme={
                  issueStatus === "PROCESSING"
                    ? "green"
                    : issueStatus === "ESCALATED"
                      ? "red"
                      : "blue"
                }
                size={"sm"}
              >
                {issueStatus}
              </Tag>
            )}
          </Flex>
          <Textarea
            placeholder="Write a brief response..."
            value={shortdescription}
            onChange={(e) => setShortDescription(e.target.value)}
            focusBorderColor="teal.500"
            borderRadius="md"
          />
        </Box>

        {/* {status === "RESOLVED" ? (
              <Flex justify={"end"} w={"100%"} align={"center"} gap={2}>
                <Button
                  colorScheme="teal"
                  onClick={() => setStep(2)} // Move to step 2 when resolved is selected
                  rightIcon={<ArrowRightIcon />}
                  boxShadow="md"
                  size={"sm"}
                  _hover={{ boxShadow: "xl" }}
                >
                  Next
                </Button>
              </Flex>
            ) : ( */}
        <Flex justify={"space-between"} w={"100%"} align={"center"} gap={2}>
          {/* Left Button */}
          <Button
            colorScheme="teal"
            onClick={() => sendToSeller()}
            boxShadow="md"
            size={"sm"}
            _hover={{ boxShadow: "xl" }}
          >
            Raise Issue to Seller
          </Button>

          <Button
            colorScheme="teal"
            onClick={() => UpdateStatus()}
            rightIcon={<ArrowRightIcon />}
            boxShadow="md"
            size={"sm"}
            _hover={{ boxShadow: "xl" }}
          >
            Respond
          </Button>
        </Flex>
      </VStack>
    </Box>
  );
}
